module.exports = __webpack_public_path__ + "0ca2c7bb447021fc61b2ddb1b831959a.png";